<template>
  <div class="master-ledger-page">
    <el-button type='primary' @click="() => exportClick(selection)"><i class='el-icon-download'></i> {{ $t('bean.actionExport') }}</el-button>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_amount_in_ledger') }}
          </div>
          <div class="statistics">
            XOF {{ this.$options.filters.currencyFormat(data.total_amount_in_ledger) }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_amount_in_agent_wallets') }}
          </div>
          <div class="statistics">
            XOF {{ this.$options.filters.currencyFormat(data.total_amount_in_agent_wallets) }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_amount_in_client_wallets') }}
          </div>
          <div class="statistics">
            XOF {{ this.$options.filters.currencyFormat(data.total_amount_in_client_wallets) }}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_number_of_agent_wallets_created') }}
          </div>
          <div class="statistics">
            {{ data.total_number_of_agent_wallets_created }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_number_of_client_wallets_created') }}
          </div>
          <div class="statistics">
            {{ data.total_number_of_client_wallets_created }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_number_of_actived_agent_wallets') }}
          </div>
          <div class="statistics">
            {{ data.total_number_of_actived_agent_wallets }}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_number_of_actived_user_wallets') }}
          </div>
          <div class="statistics">
            {{ data.total_number_of_actived_user_wallets }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_amount_of_cashback_given') }}
          </div>
          <div class="statistics">
            XOF {{ this.$options.filters.currencyFormat(data.total_amount_of_cashback_given) }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.total_number_of_transactions') }}
          </div>
          <div class="statistics">
            {{ this.$options.filters.currencyFormat(data.total_number_of_transactions) }}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="8">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.average_transactions') }}
          </div>
          <div class="statistics">
            XOF {{ this.$options.filters.currencyFormat(data.average_transactions) }}
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card>
          <div slot="header">
            {{ $t('masterLedger.cashback_amount_trend') }}
          </div>
          <div>
            <ECharts :options="cashbackAmountLineOptions" style="width:100%" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';

@Component({
  components: {
    ECharts,
  }
})
export default class MasterLedger extends Vue {
  data = {
    users_count: 0,
    new_users_trend: [],
    new_admin_roles_users_trend: []
  }

  chartBaseConfig = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: []
    },
    xAxis: {
      type: 'category',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/master_ledger')
  }

  get cashbackAmountLineOptions() {
    const legendData = [this.$t('masterLedger.cashback_amount_trend')]

    return _.merge({}, this.chartBaseConfig, {
      legend: {
        data: legendData
      },
      xAxis: {
        data: Object.keys(this.data.cashback_amount_trend)
      },
      yAxis: {
        minInterval: 1
      },
      series: _.map([
        this.data.cashback_amount_trend
      ], (element, index) => {
        return {
          name: legendData[index],
          type: 'line',
          data: Object.values(element)
        }
      })
    })
  }

  async exportClick() {
    await this.$request.get('/dashboard/export_wallet_statistic_data', { ...this.$route.query });
    this.$message.success(this.$t('exporting'));
  }
}
</script>

<style lang="scss">
  .master-ledger-page {
    margin: 15px;

    .export-button {
      margin-bottom: 15px;
    }

    .el-row {
      margin-bottom: 20px;
    }

    .el-card {
      .el-card__header {
        padding: 10px;
        font-size: 14px;
        color: #909399;
        text-align: center;
        font-weight: bold;
      }

      .statistics {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
</style>

